// extracted by mini-css-extract-plugin
module.exports = {"container":"DropdownSelector_container__12Cng"};